/**
 * Normalizes API pagination response to the format expected by frontend components.
 * API uses Pagy field names (count, pages, page); frontend expects (total_count, total_pages, current_page).
 * Idempotent — already-normalized objects pass through unchanged.
 */
export const normalizePagination = (pagination) => {
  if (!pagination) {
    return { total_count: 0, total_pages: 0, current_page: 1, from: 0, to: 0 };
  }

  return {
    total_count: pagination.total_count ?? pagination.count ?? 0,
    total_pages: pagination.total_pages ?? pagination.pages ?? 0,
    current_page: pagination.current_page ?? pagination.page ?? 1,
    from: pagination.from ?? 0,
    to: pagination.to ?? 0,
  };
};

export const calculateAvailablePages = (
  backendNext,
  backendPrev,
  currentNextPage,
  loadedPagesSet,
  knownLastPage = null,
) => {
  if (loadedPagesSet.size === 0) {
    return { actualPrevPage: backendPrev, actualNextPage: backendNext };
  }

  const minPageLoaded = Math.min(...loadedPagesSet);
  const maxPageLoaded = Math.max(...loadedPagesSet);

  const actualPrevPage = minPageLoaded > 1 ? minPageLoaded - 1 : null;

  const isLastPageReached =
    knownLastPage !== null && maxPageLoaded >= knownLastPage;

  if (isLastPageReached) {
    return { actualPrevPage, actualNextPage: null };
  }

  const nextPageCandidates = [backendNext, currentNextPage, maxPageLoaded + 1];
  const actualNextPage =
    nextPageCandidates.find(
      (page) => page != null && !loadedPagesSet.has(page),
    ) ?? null;

  return { actualPrevPage, actualNextPage };
};
